module.exports = {
    cdnRoot: "https://tier33.com"
}

// http://tier33.com.s3-website-us-east-1.amazonaws.com